import { InvoiceData } from "../../types/type";

export default function RecipientInfo({ invoiceData }: { invoiceData: InvoiceData }) {
    return (
        <div className="bg-white p-4 rounded-lg shadow-sm">
            <h2 className="text-md font-medium text-gray-800 mb-3">Recipient Information</h2>
            <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                    <span className="text-gray-600">Name:</span>
                    <span className="whitespace-normal text-right font-medium">{invoiceData.recipient.name}</span>
                </div>
                <div className="flex justify-between">
                    <span className="text-gray-600">Email:</span>
                    <span className="whitespace-normal text-right font-medium">{invoiceData.recipient.email}</span>
                </div>
            </div>
        </div>
    )
}